var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('protection-base',{attrs:{"product":_vm.product}},_vm._l((_vm.productBrochures),function(brochure,index){return _c('img',{key:index,staticClass:"w-100",attrs:{"src":brochure.link,"alt":brochure.label,"data-test":"image"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }